/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

export type GetWebparseExtractimagesRequest = { url: string };

export const GetWebparseExtractimagesRequest$zodSchema: z.ZodType<
  GetWebparseExtractimagesRequest
> = z.object({
  url: z.string().describe("需要提取图片的网页URL"),
});

export type GetWebparseExtractimagesInternalServerErrorDetails = {};

export const GetWebparseExtractimagesInternalServerErrorDetails$zodSchema:
  z.ZodType<GetWebparseExtractimagesInternalServerErrorDetails> = z.object({});

/**
 * 服务器内部错误
 */
export type GetWebparseExtractimagesInternalServerErrorResponseBody = {
  code?: string | undefined;
  details?: GetWebparseExtractimagesInternalServerErrorDetails | undefined;
  message?: string | undefined;
};

export const GetWebparseExtractimagesInternalServerErrorResponseBody$zodSchema:
  z.ZodType<GetWebparseExtractimagesInternalServerErrorResponseBody> = z.object(
    {
      code: z.string().optional(),
      details: z.lazy(() =>
        GetWebparseExtractimagesInternalServerErrorDetails$zodSchema
      ).optional(),
      message: z.string().optional(),
    },
  ).describe("服务器内部错误");

export type GetWebparseExtractimagesBadRequestDetails = {};

export const GetWebparseExtractimagesBadRequestDetails$zodSchema: z.ZodType<
  GetWebparseExtractimagesBadRequestDetails
> = z.object({});

/**
 * URL参数缺失或无效
 */
export type GetWebparseExtractimagesBadRequestResponseBody = {
  code?: string | undefined;
  details?: GetWebparseExtractimagesBadRequestDetails | undefined;
  message?: string | undefined;
};

export const GetWebparseExtractimagesBadRequestResponseBody$zodSchema:
  z.ZodType<GetWebparseExtractimagesBadRequestResponseBody> = z.object({
    code: z.string().optional(),
    details: z.lazy(() => GetWebparseExtractimagesBadRequestDetails$zodSchema)
      .optional(),
    message: z.string().optional(),
  }).describe("URL参数缺失或无效");

/**
 * 成功响应
 */
export type GetWebparseExtractimagesResponseBody = {
  count?: number | undefined;
  images?: Array<string> | undefined;
  url?: string | undefined;
};

export const GetWebparseExtractimagesResponseBody$zodSchema: z.ZodType<
  GetWebparseExtractimagesResponseBody
> = z.object({
  count: z.int().optional(),
  images: z.array(z.string()).optional(),
  url: z.string().optional(),
}).describe("成功响应");

export type GetWebparseExtractimagesResponse =
  | GetWebparseExtractimagesResponseBody
  | GetWebparseExtractimagesBadRequestResponseBody
  | GetWebparseExtractimagesInternalServerErrorResponseBody;

export const GetWebparseExtractimagesResponse$zodSchema: z.ZodType<
  GetWebparseExtractimagesResponse
> = z.union([
  z.lazy(() => GetWebparseExtractimagesResponseBody$zodSchema),
  z.lazy(() => GetWebparseExtractimagesBadRequestResponseBody$zodSchema),
  z.lazy(() =>
    GetWebparseExtractimagesInternalServerErrorResponseBody$zodSchema
  ),
]);
